import React, { useState } from 'react';
import { Space, Grid } from 'antd';
import { ProCard, QueryFilter } from '@ant-design/pro-components';
import type { QueryFilterProps } from '@ant-design/pro-components';
import { createStyles } from 'antd-style';

const useStyles = createStyles(({ token }) => ({
  card: {
    marginBottom: token.margin,
  },
  container: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
    gap: token.marginXXL,
    flexWrap: 'wrap',
  },
  leftContent: {
    display: 'flex',
    alignItems: 'flex-start',
    width: '100%',
    flex: 1,
    gap: token.marginMD,
    minWidth: 0, // Fix flex overflow
  },
  title: {
    fontSize: token.fontSizeXL,
    fontWeight: token.fontWeightStrong,
    color: token.colorTextHeading,
    lineHeight: '32px', // Align with input height
    whiteSpace: 'nowrap',
  },
  filter: {
    flex: 1,
    padding: '0 !important',
    width: '100%',
    '& .ant-pro-query-filter-row': {
      padding: '0 !important',
    },
    '& .ant-form-item': {
      marginBottom: 0,
    },
    '& .ant-col-12': {
      flex: 'none',
    },
  },
  actions: {
    flexShrink: 0,
    // Align with the first row of inputs
    paddingTop: 0,
    display: 'flex',
    gap: token.marginXS,
  },
}));

export type SearchCardProps = Omit<QueryFilterProps, 'title'> & {
  /** 标题 */
  title?: React.ReactNode;
  /** 右侧操作区内容 */
  extra?: React.ReactNode;
};

/**
 * SearchCard 搜索卡片组件
 * 封装了 QueryFilter 和常用的操作按钮
 */
const SearchCard: React.FC<SearchCardProps> = (props) => {
  const { title, extra, children, style, ...queryFilterProps } = props;
  const { styles } = useStyles();
  const { useBreakpoint } = Grid;
  const screens = useBreakpoint();

  const [collapsed, setCollapsed] = useState(true);

  return (
    <ProCard
      bordered={false}
      // bodyStyle={{ padding: '24px 24px 24px' }}
      className={styles.card}
      // style={style}
    >
      {screens.md && title && !collapsed && (
        <div className={styles.title} style={{ marginBottom: 12 }}>
          {title}
        </div>
      )}

      <div
        style={{display:'flex',alignItems:"flex-start",justifyContent:"space-between",gap:"20px",flexDirection:collapsed && screens.xxl ? "row" : "column"}}
      >
        <div className={styles.leftContent}>
          {screens.md && title && collapsed && (
            <div className={styles.title}>{title}</div>
          )}

          <div style={{width:"100%",minWidth:0}}>
            <QueryFilter
              span={!screens.xl ? 24 : (collapsed ? 12 : 8)}
              defaultCollapsed
              layout="horizontal"
              labelWidth="auto"
              className={collapsed ? styles.filter : ''}
              {...queryFilterProps}
              style={{ padding: 0 }}
              defaultColsNumber={1}
              collapsed={collapsed}
              onCollapse={setCollapsed}
            >
              {children}
            </QueryFilter>
          </div>
        </div>

        <div
          style={{flexShrink:1,justifyContent:"flex-end",display:"flex",flexWrap:!collapsed ? "wrap" : "nowrap",width:screens.xxl ? "auto" : "100%"}}
        >
          <Space size="small"  style={{flexWrap:"wrap",justifyContent:"flex-end"}}>
            {extra}
          </Space>
        </div>
      </div>
    </ProCard>
  );
};

export default SearchCard;
